import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPaperplane24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconPaperplane24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M19.388 11.779a.25.25 0 0 1 0 .447L4.863 19.469a.25.25 0 0 1-.357-.27l1.203-6.445h6.29a.75.75 0 0 0 0-1.5H5.71L4.506 4.807a.25.25 0 0 1 .357-.27zm.67 1.79c1.292-.644 1.292-2.488 0-3.132L5.533 3.195c-1.294-.644-2.767.467-2.502 1.887l1.283 6.875a.3.3 0 0 1 0 .092l-1.283 6.874c-.265 1.42 1.208 2.532 2.502 1.887z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPaperplane24);
